/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (bipro-partner::Kommunikationstyp)     * `EMail`         - german: E-Mail   * `PhoneMobile`   - german: Telefon mobil   * `PhoneLandline` - german: Telefon Festnetz
 */
export const ContactType = {
  EMail: 'EMail',
  PhoneMobile: 'PhoneMobile',
  PhoneLandline: 'PhoneLandline',
} as const;
export type ContactType = (typeof ContactType)[keyof typeof ContactType];
